<template>
    <div class="create-company-page page" style="max-width: 600px">
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <h4 class="page-title" v-if="company">
                        {{ company.name }}
                    </h4>
                </div>
            </div>
        </div>
        <div class="card card-body">
            <div v-if="!company">Loading...</div>
            <company :company="company" v-else/>
        </div>
    </div>
</template>

<script>
    import CompanyModel from "@/models/company";
    import Company from "@/components/main/Company";

    export default {
        components: {
            Company
        },
        data() {
            return {
                company: null
            }
        },
        created() {
            this.initCompany()
        },
        methods: {
            initCompany() {
                CompanyModel.find(this.$route.params.id)
                    .then((response) => {
                        this.company = response;
                    });
            }
        }
    }
</script>

<style scoped>

</style>
